// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1tfly","rootSmall":"AddTileButton_rootSmall__1UgWd"};